import { BaseService } from '@/modules/Core/services/BaseService'
import type { IMediLotes } from '../interfaces/tablas/IMediLotes'

export class LotesService extends BaseService<IMediLotes> {
  constructor () {
    super({
      baseUrl: 'medicines/batches/'
    })
  }
}
